import React, { useState, useEffect } from 'react';
import {
  FaSave, FaPlus, FaEdit, FaTrash, FaTimes,
  FaCheckCircle, FaExclamationCircle, FaRoad, FaSmile
} from 'react-icons/fa';
// 1️⃣ emoji-picker-react इम्पोर्ट किया
import EmojiPicker from 'emoji-picker-react';
import { useAdmin } from '../context/AdminContext';
import './SectionManager.css';

const JourneyManager = () => {
  const { data, addItem, updateItem, deleteItem, loading } = useAdmin();
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  
  // 2️⃣ इमोजी पिकर शो/हाइड करने के लिए स्टेट
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const [form, setForm] = useState({
    year: '',
    title: '',
    short_desc: '',
    full_desc: '',
    icon: '🏆',
    sort_order: 0,
  });

  const journeyList = data?.journey || [];

  const notifySuccess = (msg) => {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(''), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (!form.year.trim() || !form.title.trim() || !form.short_desc.trim()) {
      setErrorMsg('Year, Title, and Short Description are required!');
      return;
    }

    try {
      const payload = { ...form, sort_order: Number(form.sort_order) || 0 };

      if (editId) {
        await updateItem('journey', editId, payload);
        notifySuccess('Journey milestone updated successfully!');
      } else {
        await addItem('journey', payload);
        notifySuccess('Journey milestone added successfully!');
      }
      resetForm();
    } catch (err) {
      console.error('Error saving journey:', err);
      setErrorMsg('Failed to save. Please try again.');
    }
  };

  const handleEdit = (item) => {
    setForm({
      year: item.year || '',
      title: item.title || '',
      short_desc: item.short_desc || '',
      full_desc: item.full_desc || '',
      icon: item.icon || '🏆',
      sort_order: item.sort_order || 0,
    });
    setEditId(item.id);
    setShowForm(true);
    setShowEmojiPicker(false); // फॉर्म खोलते समय पिकर बंद रखें
    setErrorMsg('');
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this milestone?')) {
      await deleteItem('journey', id);
      notifySuccess('Milestone deleted successfully.');
    }
  };

  const resetForm = () => {
    setForm({ year: '', title: '', short_desc: '', full_desc: '', icon: '🏆', sort_order: 0 });
    setEditId(null);
    setShowForm(false);
    setShowEmojiPicker(false); // फॉर्म रीसेट होने पर पिकर बंद
    setErrorMsg('');
  };

  // 3️⃣ emoji-picker-react से इमोजी सेलेक्ट करने का हैंडलर फंक्शन
  const handleEmojiSelect = (emojiData) => {
    setForm({ ...form, icon: emojiData.emoji });
    setShowEmojiPicker(false);
  };

  if (loading && journeyList.length === 0) {
    return (
      <div className="sg-manager">
        <div className="gl-loader">
          <p>Loading journey data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sg-manager">
      <div className="sg-page-header">
        <div className="sg-ph-left">
          <div className="sg-ph-icon"><FaRoad /></div>
          <div className="sg-ph-text">
            <h2>Journey Manager</h2>
            <p>Add and manage your personal and business journey milestones</p>
          </div>
        </div>
        <div className="sg-ph-right">
          <button className="sg-btn-gold" onClick={() => setShowForm(!showForm)}>
            {showForm ? <><FaTimes /> Close</> : <><FaPlus /> Add Milestone</>}
          </button>
        </div>
      </div>

      {successMsg && (
        <div className="sg-alert sg-alert-success"><FaCheckCircle /> {successMsg}</div>
      )}
      {errorMsg && (
        <div className="sg-alert sg-alert-error"><FaExclamationCircle /> {errorMsg}</div>
      )}

      {showForm && (
        <div className="sg-form-card">
          <div className="sg-form-header">
            <div>
              <h3>{editId ? 'Edit Milestone' : 'Add New Milestone'}</h3>
              <p>Enter details about this journey milestone</p>
            </div>
            <button className="sg-form-close" onClick={resetForm}><FaTimes /></button>
          </div>

          <form onSubmit={handleSubmit} className="sg-form">
            <div className="sg-form-row-3">
              <div className="sg-field">
                <label>Year <span className="req">*</span></label>
                <input type="text" value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} placeholder="e.g. 1995" required />
              </div>
              <div className="sg-field">
                <label>Title <span className="req">*</span></label>
                <input type="text" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="e.g. Birth, Schooling" required />
              </div>
              
              {/* 4️⃣ SERVICES MANAGER की तरह सेम स्टाइल में इमोजी इनपुट ग्रुप */}
              <div className="sg-field" style={{ position: 'relative' }}>
                <label>Icon (Emoji)</label>
                <div className="sg-input-group">
                  <input
                    type="text"
                    value={form.icon}
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    onChange={(e) => setForm({ ...form, icon: e.target.value })}
                    placeholder="Click to pick emoji 🏆"
                    style={{ cursor: 'pointer' }}
                    required
                  />
                  <button
                    type="button"
                    className="sg-input-btn"
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                  >
                    <FaSmile />
                  </button>
                </div>

                {/* emoji-picker-react पॉपअप */}
                {showEmojiPicker && (
                  <div className="sg-emoji-picker-wrap">
                    <EmojiPicker onEmojiClick={handleEmojiSelect} height={350} width={320} />
                  </div>
                )}
              </div>
            </div>

            <div className="sg-field">
              <label>Short Description <span className="req">*</span></label>
              <textarea value={form.short_desc} onChange={(e) => setForm({ ...form, short_desc: e.target.value })} rows="3" placeholder="Short description shown on timeline card..." required />
            </div>

            <div className="sg-field">
              <label>Full Description (Popup Detail)</label>
              <textarea value={form.full_desc} onChange={(e) => setForm({ ...form, full_desc: e.target.value })} rows="8" placeholder="Detailed description shown when user clicks 'Read Full Story'..." />
            </div>

            <div className="sg-field" style={{ maxWidth: '200px' }}>
              <label>Sort Order</label>
              <input type="number" value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: e.target.value })} placeholder="0" />
            </div>

            <div className="sg-form-actions">
              <button type="submit" className="sg-btn-gold">
                <FaSave /> {editId ? 'Update Milestone' : 'Save Milestone'}
              </button>
              <button type="button" className="sg-btn-outline" onClick={resetForm}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div className="sg-table-card">
        <div className="sg-table-header">
          <div>
            <h3>Journey Milestones</h3>
            <p>All milestones in chronological order</p>
          </div>
          <span className="sg-count-badge">{journeyList.length} Total</span>
        </div>

        <div className="sg-table-wrap">
          <table className="sg-table">
            <thead>
              <tr>
                <th style={{ width: '60px' }}>Icon</th>
                <th style={{ width: '80px' }}>Year</th>
                <th>Title</th>
                <th>Short Description</th>
                <th style={{ width: '120px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {journeyList.length === 0 ? (
                <tr>
                  <td colSpan="5" className="sg-empty">
                    <div className="sg-empty-inner">
                      <FaRoad />
                      <h4>No Journey Milestones Yet</h4>
                      <p>Click "Add Milestone" to start building your journey timeline</p>
                    </div>
                  </td>
                </tr>
              ) : (
                journeyList.map((item) => (
                  <tr key={item.id}>
                    <td data-label="Icon"><span style={{ fontSize: '28px' }}>{item.icon || '🏆'}</span></td>
                    <td data-label="Year"><strong style={{ color: '#c9a227', fontFamily: 'Playfair Display, serif', fontSize: '18px' }}>{item.year}</strong></td>
                    <td data-label="Title"><strong className="sg-row-title">{item.title}</strong></td>
                    <td data-label="Description"><span className="sg-row-desc">{(item.short_desc || '').slice(0, 80)}{(item.short_desc || '').length > 80 ? '...' : ''}</span></td>
                    <td data-label="Actions">
                      <div className="sg-actions">
                        <button className="sg-action-btn sg-edit" onClick={() => handleEdit(item)} title="Edit"><FaEdit /></button>
                        <button className="sg-action-btn sg-delete" onClick={() => handleDelete(item.id)} title="Delete"><FaTrash /></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default JourneyManager;